module.exports = __webpack_public_path__ + "media/images/icon/payment-6822ca4f2caf42cffecc7c43f183cb1e.svg";